import { connect } from "react-redux";
import {
  Creators,
  getQuickAddDrawerVisibility,
} from "../../reducer";
import QuickAddDrawer from "./QuickAddDrawer";

export default connect(
  state => ({
    drawerVisibility: getQuickAddDrawerVisibility(state),
  }),
  dispatch => ({
    onUpdateQuickAddDrawerVisibility: (visibility) =>
      dispatch(Creators.updateQuickAddDrawerVisibility(visibility))
  })
)(QuickAddDrawer);



// WEBPACK FOOTER //
// ./src/staff/components/QuickAddDrawer/index.js